var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"267618b2a011188d3bd70ef9121137a97040b6be"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["webapp-frontend@mizar"]={id:"267618b2a011188d3bd70ef9121137a97040b6be"};
      